import { Fragment } from "react"

import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

import {
    ESpecialChar,
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    SpecialChars,
    Typography
} from "@/3514/components"
import { SelfEnrollmentBlock } from "@/features/self-enrollment"
import { SimpleLayout } from "@/layouts"

const AssignModulePage = () => {
    const { t } = useTranslation()

    return (
        <SimpleLayout
            showProfilePhoto
            withFooter={false}
            className="pb-[40px] md:pb-[100px]"
            mainClassName="flex justify-center"
            _withNoSidebarSpacingOffset
        >
            <Typography
                text={
                    <Fragment>
                        <span className="font-extrabold">{t("Module:")}</span>
                        {SpecialChars[ESpecialChar.EmptySpace]}
                        <span className="font-italic">{t("common.unassigned")}</span>
                    </Fragment>
                }
                className="mb-[30px] mt-4"
                alignment={ETypographyAlignment.Center}
                tag={ETypographyTag.Heading1}
                color={ETypographyColor.Black}
                weight={ETypographyWeight.Medium}
                size={ETypographySize.Heading1}
                family={ETypographyFamily.DmSerif}
            />

            <motion.div
                key="block"
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.25, delay: 0.3, ease: "easeIn" }}
            >
                <SelfEnrollmentBlock />
            </motion.div>
        </SimpleLayout>
    )
}

export default AssignModulePage
